<template>
    <v-layout>
        <v-flex class="print-config-layout__icon">
            <div class="print-config-layout__icon-inner">
                <slot name="icon"/>
            </div>
        </v-flex>
        <v-flex class="print-config-layout__text">
            <slot name="text"/>
        </v-flex>
        <v-flex class="print-config-layout__answer">
            <slot name="answer"/>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "print-config-layout"
    }
</script>

<style lang="scss">
    .print-config-layout {
        &__icon-inner {
            padding-right: 10px;
            text-align: center;
            .print-config-icon--small {
                font-size: 1.2rem;
            }
            .print-config-icon--extra-small {
                font-size: .9rem;
            }
        }
        &__icon {
            flex: 0 0 auto;
            width: 5%;
        }

        &__text {
            width: 75%
        }

        &__answer {
            width: 20%
        }
    }
</style>